export default "__VITE_ASSET__C$_$MtPg__"